import { FC, Fragment } from "react";

import { useCurrentUserContext } from "modules/login";
import { roleStatusMap } from "modules/users/components/configs/userTableAccountConfig";
import { Accounts } from "modules/users/components/userTable/userTable.types";
import { USER_TYPE } from "modules/users/types/UserTypesEnum";
import { XIcon } from "ui/icons";

import { AccountNameStyle, RoleStyle, StyleAccountTaps, TextWrapper } from "./roleTile.styles";

type RoleTileProps = {
  accountDetails: Accounts;
  closeButton?: boolean;
  handleCloseButton?: (accountDetails: Accounts) => void;
};

export const RoleTile: FC<RoleTileProps> = ({ accountDetails, closeButton = false, handleCloseButton }) => {
  const { accountName, role } = accountDetails;
  const prettyRole = roleStatusMap[role].label;
  const isInternal = role.includes(USER_TYPE.internal);

  const {
    userDetails: { userId }
  } = useCurrentUserContext();

  const isUserMyself = accountDetails.userId === userId;

  const showRemoveButton = !isUserMyself && closeButton;

  const handleCloseButtonClick = () => handleCloseButton?.(accountDetails);

  return (
    <Fragment key={accountName + role}>
      <StyleAccountTaps>
        <TextWrapper>
          <AccountNameStyle isIntenal={isInternal}>{`${accountName}: `}</AccountNameStyle>
          <RoleStyle>{prettyRole}</RoleStyle>
        </TextWrapper>
        {showRemoveButton && (
          <XIcon style={{ cursor: "pointer" }} width="6.6" height="8.36" onClick={handleCloseButtonClick} />
        )}
      </StyleAccountTaps>
    </Fragment>
  );
};
